export type TopologyVector = {
    readonly geometryOffsets?: Uint32Array;
    readonly partOffsets?: Uint32Array;
    readonly ringOffsets?: Uint32Array;
};
